<script lang="ts">
	export let title: string;
	export let icon: string;
</script>

<div class="irrigation-card">
	<div class="irrigation-card-section">
		<div class="irrigation-card-row">
			<div class="irrigation-card-icon">
				<i class={icon}></i>
			</div>
			<span>{title}</span>
		</div>
		<slot />
	</div>
</div>

<style>
	.irrigation-card {
		background: #121517;
		border-radius: 12px;
		overflow: hidden;
		margin-bottom: 12px;
	}
	.irrigation-card-section {
		padding: 16px 20px;
	}
	.irrigation-card-row {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 8px;
		color: #8e8e93;
		font-size: 14px;
	}
	.irrigation-card-icon {
		font-size: 16px;
	}
</style>
